export default __webpack_public_path__ + "static/media/pexels-snapwire-618612.6ca81a23.jpg";